<template>
  <div>
    <custom-callout border-color="green" class="mb-4" :has-toggle="false">
      <validation-observer ref="searchValidator" novalidate tag="form">
        <div class="mt-3  container-search">
          <div class="col-12 col-md-6">
            <div class="row ">
              <div class="col-12 pl-0">
                <icon-view
                  class="mx-0 mb-2"
                  icon="fas fa-file-plus"
                  icon-background="#fff"
                  icon-color="#2db782"
                  icon-size="14px"
                  title="Añadir Tarjeta"
                />
              </div>
            </div>

            <div class="row mr-md-1">
              <div class="col-12 col-md-8 pl-0">
                <span class="title-add-card">Número de Estudiante:</span>
                <validation-provider
                  ref="searchText"
                  v-slot="{ errors }"
                  :custom-messages="{
                    required: 'El número de SIE es requerido.',
                    studentSie: 'El número de SIE no es correcto.',
                  }"
                  rules="required|studentSie"
                >
                  <custom-input
                    id="searchText"
                    v-model="searchText"
                    class="pt-2"
                    :custom-error-msg="errors[0]"
                    :error="errors[0]"
                    maxlength="8"
                    placeholder="Escriba número de SIE"
                    type="text"
                  />
                </validation-provider>
              </div>
              <div class="col-12 col-md-3 pt-2">
                <action-button
                  i="fa fa-search "
                  text="searchText"
                  variant="success btn-block mt-4"
                  @click="search"
                >
                  Buscar
                </action-button>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>

      <div v-if="studentSelected">
        <span class="row mt-3 mb-3">
          <i class="fas fa-info-circle custom-color-icon mr-2 mt-1" />
          <span class="title-icon-view font-16 font-weight-bold">
            <strong>Información del Estudiante</strong>
          </span>
        </span>

        <div class="row  col-12 mt-2 white-panel  pr-5 border-left pt-3 pl-5">
          <div class="col-sm-12 col-md-2 px-0">
            <span class="title-add-card ">Nombre:</span>
            <p>{{ this.studentFullName }}</p>
          </div>
          <div class="col-sm-12 col-md-2 px-0">
            <span class="title-add-card">SIE:</span>

            <p>{{ this.selectedStudent.studentId }}</p>
          </div>
          <div class="col-sm-12 col-md-2 px-0">
            <span class="title-add-card">Edad:</span>
            <p>{{ this.studentAge }}</p>
          </div>

          <div class="col-sm-12 col-md-2 px-0">
            <span class="title-add-card">Fecha de Nacimiento:</span>

            <p>{{ formatDate(this.selectedStudent.birthdate) }}</p>
          </div>
          <div class="col-sm-12 col-md-3 px-0">
            <span class="title-add-card">SSN:</span>
            <br />
            <span>
              <span v-if="!showSsnNumber" class="pl-1">
                {{ ssnFormat(this.selectedStudent.ssn) }}
              </span>
              <span v-if="showSsnNumber" class="pl-1">
                {{ ssnFormat(this.selectedStudent.ssnNumber) }}
              </span>
              <i
                v-if="userCanViewSsn && !showSsnNumber"
                class="mt-1 ml-2 fa fa-eye-slash cursor-pointer"
                @click.prevent.stop="onShowSsn()"
              />
              <i
                v-if="userCanViewSsn && showSsnNumber"
                class="mt-1 ml-2 fa fa-eye cursor-pointer"
                @click.prevent.stop="onShowSsn()"
              />
            </span>
          </div>

          <div class="col-12 px-0 col-md-1 ">
            <span class="title-add-card ml-5">Estatus:</span>

            <p class="ml-5">{{ this.selectedStudent.status }}</p>
          </div>
        </div>
      </div>
      <br />
      <hr v-if="showCardFields" />

      <div class="container-form">
        <validation-observer ref="addCardFormValidator" novalidate tag="form">
          <div v-if="showCardFields" class="row col-12 mt-3 py-3 px-0 ">
            <div class="row col-12 mb-3">
              <div class="col-12 col-md-4 mb-3">
                <div class="title-add-card mb-2">
                  Año Académico:
                </div>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="selectedAcademicYear"
                    :clearable="false"
                    custom-error-msg="El año académico es requerido."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="description"
                    :options="catalog.academicYears"
                    placeholder="Seleccione año academico"
                    @input="onAcademicYearChanged"
                  />
                </validation-provider>
              </div>
              <div class="col-12 col-md-4  mb-3">
                <div class="title-add-card font-14 mb-2">
                  Región Educativa:
                </div>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="card.region"
                    :clearable="false"
                    custom-error-msg="La región educativa es requerida."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="catalog.regions"
                    placeholder="Seleccione"
                    @input="onRegionChanged"
                  />
                </validation-provider>
              </div>

              <div class="col-12 col-md-4  mb-3">
                <div class="title-add-card mb-2">
                  Centro:
                </div>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="card.center"
                    :clearable="false"
                    custom-error-msg="El centro es requerido."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="catalog.centers"
                    placeholder="Seleccione"
                    @input="onCenterChanged"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="row col-12  mb-3">
              <div class="col-12 col-md-4">
                <div class="title-add-card mb-2">
                  Municipio:
                </div>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="card.municipality"
                    :clearable="false"
                    custom-error-msg="El muncipio es requerido."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="catalog.municipalities"
                    placeholder="Seleccione"
                    @input="onMunicipalityChanged"
                  />
                </validation-provider>
              </div>
              <div class="col-12 col-md-4  mb-3">
                <div class="title-add-card mb-2">
                  Escuela:
                </div>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="card.school"
                    :clearable="false"
                    custom-error-msg="La escuela es requerida."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="catalog.schools"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>

              <div class="col-12 col-md-4  mb-3">
                <div class="title-add-card mb-2">
                  Estatus de la Tarjeta:
                </div>
                <validation-provider v-slot="{ errors }" rules="required">
                  <custom-drop-down
                    v-model="card.status"
                    :clearable="false"
                    custom-error-msg="El estatus de la tarjeta es requerido."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="cardStatuses"
                    placeholder="Seleccione"
                  />
                </validation-provider>
              </div>
            </div>

            <!-- Botones -->
            <div class="row col-12 mt-3">
              <div class="col-md-4 offset-8 text-right">
                <action-button
                  class="flex-grow-1"
                  i="fas fa-times-circle"
                  variant="outline-danger btn-cancel danger m-2"
                  @click="closeAddCard()"
                >
                  Cancelar
                </action-button>
                <action-button
                  class="flex-grow-1"
                  i="fas fa-file-plus"
                  variant="success"
                  @click="addCardHandler()"
                >
                  Añadir
                </action-button>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
    </custom-callout>
  </div>
</template>

<script>
import { CustomDropDown } from '@/components/common';
import {
  getStudentDetails as _getStudentDetails,
  getStudentSsn as _getStudentSsn,
} from '@/modules/shared/provider.api';
import { getStudentHasCard as _getStudentHasCard } from '@/modules/shared/cardHandling.api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ActionButton from '@/components/common/ActionButton.vue';
import alertMixin from '@/mixins/alert.mixin.js';
import CustomCallout from 'custom-callout';
import CustomInput from '@/components/common/form/CustomInput';
import IconView from './IconView';
import { getAcademicYearsToCurrentYear as _getAcademicYearsToCurrentYear } from '@/modules/shared/academicyear.api';
import {
  getCenters as _getCenters,
  getMunicipalities as _getMunicipalities,
  getSchools as _getSchools,
  getRegions as _getRegions,
} from '@/modules/shared/location.api.js';
import {
  addCard as _addStudentCard,
  getStudentLocationSchoolForCard as _getStudentLocationSchoolForCard,
} from '@/modules/shared/cardHandling.api.js';
import moment from 'moment';

export default {
  name: 'AddCard',
  emits: ['update:activate'],
  components: {
    ActionButton,
    CustomCallout,
    CustomDropDown,
    CustomInput,
    IconView,
    ValidationObserver,
    ValidationProvider,
  },
  mixins: [alertMixin],
  props: {
    activate: {
      type: Boolean,
      default: false,
    },
    cardStatuses: {
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      currentYear: '',
      searchText: '',
      selectedAcademicYear: '',
      selectedStudent: {
        studentId: '',
        firstName: '',
        middleName: '',
        lastName: '',
        ssn: '',
        status: '',
        birthdate: '',
        ssnNumber: '',
      },
      card: {
        center: '',
        school: '',
        municipality: '',
        region: '',
        status: '',
      },
      catalog: {
        centers: [],
        municipalities: [],
        schools: [],
        academicYears: [],
        regions: [],
      },
      showSsnNumber: false,
    };
  },
  computed: {
    saveDisabled() {
      return (
        this.card.region === '' ||
        this.card.center === '' ||
        this.card.municipality === '' ||
        this.card.status === '' ||
        this.card.school === '' ||
        this.selectedStudent.studentId === '' ||
        this.selectedAcademicYear === ''
      );
    },
    userCanViewSsn() {
      return this.userHasPermissions(
        'provider.scholarship.cardhandling.canviewssn'
      );
    },
    studentSelected() {
      return this.selectedStudent.studentId !== '';
    },
    studentAge() {
      let age = Math.trunc(this.selectedStudent?.age);
      return age ? age : '-';
    },
    studentBirthdate() {
      if (
        this.selectedStudent.birthdate !== '' &&
        this.selectedStudent.birthdate !== undefined &&
        this.selectedStudent.birthdate !== null
      ) {
        const bdate = new Date(this.selectedStudent?.birthdate);
        return bdate.toLocaleDateString();
      }

      return '';
    },
    studentFullName() {
      return `${this.selectedStudent.firstName} ${
        this.selectedStudent.middleName ? this.selectedStudent.middleName : ''
      } ${this.selectedStudent.lastName}`.replace('  ', ' ');
    },
    studentMaskedSsn() {
      var replacedSsn = this.selectedStudent.ssn;

      var finalSsn = [replacedSsn.slice(0, 3), '-', replacedSsn.slice(3)].join(
        ''
      );
      finalSsn = [finalSsn.slice(0, 6), '-', finalSsn.slice(6)].join('');
      return finalSsn;
    },
    showCardFields() {
      return (
        this.selectedStudent?.studentId != undefined &&
        this.selectedStudent?.studentId != null &&
        this.selectedStudent?.studentId != ''
      );
    },
  },
  mounted() {
    this.loadInitCatalogs();
  },
  methods: {
    async loadInitCatalogs() {
      this.currentYear = (await this.currentAcademicYear()).id;

      this.catalog.academicYears = (
        await _getAcademicYearsToCurrentYear()
      ).data;

      const municipalities = await _getMunicipalities({
        academicYearId: this.currentYear,
      });
      this.catalog.municipalities = municipalities.data;

      const centers = await _getCenters({ academicYearId: this.currentYear });
      this.catalog.centers = centers.data;

      const schools = await _getSchools({ academicYearId: this.currentYear });
      this.catalog.schools = schools.data;

      const regions = await _getRegions({ academicYearId: this.currentYear });
      this.catalog.regions = regions.data;
    },
    clearSelectedStudent() {
      this.selectedStudent = {
        studentId: '',
        firstName: '',
        middleName: '',
        lastName: '',
        ssn: '',
        status: '',
        birthdate: '',
        region: { id: '', name: '' },
        center: { id: '', name: '' },
        municipality: { id: '', name: '' },
      };
      this.showSsnNumber = false;
    },
    async search() {
      const isValid = await this.$refs.searchValidator.validate();

      if (!isValid) return;

      this.clearSelectedStudent();

      let student;

      try {
        const { data: studentInfo } = await _getStudentDetails(this.searchText);

        if (!studentInfo || !studentInfo?.studentId) {
          this.ShowToast(
            'Alerta',
            'No se encontró número de SIE en sistema.',
            'error'
          );
          return;
        }

        student = studentInfo;
      } catch (error) {
        this.ShowToast(
          'Alerta',
          'No se encontró número de SIE en sistema.',
          'error'
        );
        return;
      }

      const { data: hasCard } = await _getStudentHasCard(this.searchText);

      if (hasCard) {
        this.ShowToast(
          '',
          'El número de SIE ya cuenta con una tarjeta en sistema.',
          'error'
        );
        return;
      }

      const {
        data: studentSchoolInfo,
      } = await _getStudentLocationSchoolForCard(student.studentId);

      this.card.region = this.catalog.regions.find(
        (region) => region.id === studentSchoolInfo.regionId
      );
      this.card.municipality = this.catalog.municipalities.find(
        (municipality) => municipality.id === studentSchoolInfo.municipalityId
      );
      this.card.school = this.catalog.schools.find(
        (school) => school.id === studentSchoolInfo.schoolId
      );

      const { data: center } = await _getCenters({
        academicYearId: this.currentYear,
        municipalityId: studentSchoolInfo.municipalityId,
        regionId: studentSchoolInfo.regionId,
        districtId: studentSchoolInfo.districtId,
      });

      this.card.center = this.catalog.centers.find((c) => c.id == center[0].id);

      this.selectedAcademicYear = this.catalog.academicYears.find(
        (year) => year.id === this.currentYear
      );

      this.selectedStudent = student;
    },
    closeAddCard() {
      this.$emit('update:activate', false);
    },
    async addCardHandler() {
      const isValid = await this.$refs.addCardFormValidator.validate();

      if (!isValid) {
        return;
      }

      if (!this.saveDisabled) {
        const result = await _addStudentCard({
          centerId: this.card.center.id,
          locationSchoolId: this.card.school.id,
          municipalityId: this.card.municipality.id,
          regionId: this.card.region.id,
          statusId: this.card.status.id,
          studentSieId: this.selectedStudent.studentId,
        });

        if (result.status == 200) {
          this.ShowToast(
            '',
            'Se añadió la tarjeta del estudiante exitosamente.',
            'success'
          );
          this.closeAddCard();
        } else {
          this.ShowToast('', 'Error al agregar la tarjeta.', 'error');
        }
      }
    },
    async loadCenters() {
      const centers = await _getCenters({
        academicYearId: this.selectedAcademicYear.id,
        regionId: this.card.region.id,
      });
      this.catalog.centers = centers.data;
    },
    async loadMunicipalities() {
      const municipalities = await _getMunicipalities({
        academicYearId: this.selectedAcademicYear.id,
        regionId: this.card.region.id,
        centerId: this.card.center.id,
      });
      this.catalog.municipalities = municipalities.data;
    },
    async loadSchools() {
      const schools = await _getSchools({
        academicYearId: this.selectedAcademicYear.id,
        municipalityId: this.card.municipality.id,
      });
      this.catalog.schools = schools.data;
    },
    async loadRegions() {
      const regions = await _getRegions({
        academicYearId: this.selectedAcademicYear.id,
      });
      this.catalog.regions = regions.data;
    },
    async onAcademicYearChanged() {
      this.card = {
        ...this.card,
        region: '',
        center: '',
        municipality: '',
        school: '',
      };

      this.catalog = {
        ...this.catalog,
        regions: [],
        centers: [],
        municipalities: [],
        schools: [],
      };

      this.loadRegions();
    },
    async onRegionChanged() {
      this.card = {
        ...this.card,
        center: '',
        municipality: '',
        school: '',
      };

      this.catalog = {
        ...this.catalog,
        centers: [],
        municipalities: [],
        schools: [],
      };

      this.loadCenters();
    },
    async onCenterChanged() {
      this.card = {
        ...this.card,
        municipality: '',
        school: '',
      };

      this.catalog = {
        ...this.catalog,
        municipalities: [],
        schools: [],
      };

      this.loadMunicipalities();
    },
    async onMunicipalityChanged() {
      this.card = {
        ...this.card,
        school: '',
      };

      this.catalog = {
        ...this.catalog,
        schools: [],
      };

      this.loadSchools();
    },
    async onShowSsn() {
      this.showSsnNumber = !this.showSsnNumber;
      if (this.showSsnNumber) {
        this.selectedStudent.ssnNumber = this.selectedStudent.ssn;
        var result = await _getStudentSsn(this.selectedStudent.studentId);
        this.selectedStudent.ssnNumber = result.data;
        this.$forceUpdate();
      }
    },
    ssnFormat(ssn) {
      return ssn
        ? ssn.slice(0, 3) + '-' + ssn.slice(3, 5) + '-' + ssn.slice(5, 9)
        : '';
    },
    formatDate(date) {
      if (date) {
        return moment(date)
          .locale('es-PR')
          .format('DD/MMM/YYYY');
      }
    },
  },
};
</script>

<style scoped>
.white-panel {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.tag-bubble {
  background-color: #b5c3bc;
  border-radius: 25px;
  color: #fefefe;
  font-weight: bold;
  padding: 0.25rem 1rem;
}

.results-panel {
  border-left: 1px solid #e4e4e4;
}

.results-label {
  color: #a0a0a0;
}
.title-add-card {
  color: #727272;
  font-size: 14px;
}
.border-left {
  border-left: 5px solid #b4c3bc !important;
}
.custom-color-icon {
  color: #ff7058;
  font-size: 19px;
}
.container-form {
  margin-left: -15px;
  width: 103%;
}

.title-icon-view {
  color: #3f5c61;
  font-size: 16px;
}
.container-search {
  margin-left: -15px;
}
</style>
